import { Box, Typography } from "@mui/material";
import { useLanguage } from "../../../contexts/LanguageContext";
import translations from "./translations.json";

type SupportedLanguage = keyof typeof translations;

export const Loading = () => {
    const { language } = useLanguage();
    const label = translations[language as SupportedLanguage] || translations.en;

    return <Box sx={{
        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: '#fff',
    }}>
        <Typography variant="h6">{label}</Typography>
    </Box>
}